<template>
    <div class="justify-content-center mb-5" style="overflow-x: hidden;">
        <div class="row justify-content-center">
            <div class="col-md-7 mx-auto element-x-ray" style="border: 1px solid rgba(255, 255, 255, .12);">
                <p class="fts-16 mb-0 text-center h-emphasis mb-4" style="font-weight:900;">Nos dernières recommandations - {{ strategy.CPPI_recommendation_date }}</p>
                <!-- <p class="fts-16 mb-0 h-emphasis">Pour maintenir votre objectif de rendement minimal de {{ user.floor_target_rate*100}} % et sans perdre plus de {{ user.maximum_loss}} % d'ici {{ user.CPPI_end_date}} </p> -->
                <div v-if="strategy.risky_assets > 0">
                    <p class="fts-16 mb-0 h-emphasis">Le modèle de risque vous recommende d'acheter {{ formatEuros(strategy.risky_assets)}} € d'actifs risqués et de vendre {{ formatEuros(strategy.non_risky_assets) }} € d'actifs non risqués</p>
                    <p class="fts-16 mb-0 h-emphasis">Pour info, vos actifs risqués sont (add actif) et vos actifs non risqués sont (add non risqué)</p>
                </div>
                <div v-else>
                    <p class="fts-16 mb-0 h-emphasis">Le modèle de risque vous recommende de vendre {{ formatEuros(strategy.risky_assets)}} € d'actifs risqués et d'acheter {{ formatEuros(strategy.non_risky_assets) }} € d'actifs non risqués</p>
                    <p class="fts-16 mb-0 h-emphasis">Pour info, vos actifs risqués sont  </p>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-7 mx-auto element-x-ray" style="border: 1px solid rgba(255, 255, 255, .12);">
                <p class="fts-16 mb-0 text-center h-emphasis mb-4" style="font-weight:900;">Vos paramètres actuels:</p>
                <!-- <p class="fts-16 mb-0 h-emphasis">Probabilité de perte: {{ cppi_strategy.loss_probability}} </p> -->
                <p class="fts-16 mb-0 h-emphasis">Floor actuel: {{ formatEuros(cppi_strategy.floor)}} €</p>
                <p class="fts-16 mb-0 h-emphasis">Coussin actuel: {{ formatEuros(cppi_strategy.cushion)}} € </p>
                <p class="fts-16 mb-0 h-emphasis">Perte moyenne si franchissement du floor: {{ Math.round(cppi_strategy.average_loss*100)/100}} % </p>
                <p class="fts-16 mb-0 h-emphasis">Valeur du portefeuille moyenne si franchissement du floor: {{ formatEuros(cppi_strategy.average_porfolio_value)}} €</p>
                <p class="fts-16 mb-0 h-emphasis">Perte moyenne si franchissement du floor: {{ formatEuros(cppi_strategy.average_loss_value)}} €</p>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-5 my-4">
                <div class="mx-auto my-3" style="width: 250px;">
                    <select
                        class="form-control-4"
                        style="font-size: 11px; max-width: 250px; text-transform: capitalize; border: 1px solid rgba(187, 134, 252, .2)!important;"
                        v-model="client_position">
                        <option value="null" disabled>Type de risque</option>
                        <option v-for="(client_position, index) in client_positions" :key="index" :value="client_position">{{ client_position.risky_type }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="col-md-10 text-center mx-auto">
            <p class="fts-28 light-white-03" style="font-weight: 900;">Vos positions en portefeuille</p>
        </div>
        <div class="row justify-content-center" v-for="(comparison, index) in client_position.positions" :key="index">
            <input type="hidden" :id="comparison.isin" v-model="comparison.has_traded">

            <div class="col-md-10 element-x-ray m-2" style="border: 1px solid rgba(255, 255, 255, .12);" v-if="comparison.has_traded == 0">
                <div style="width: 90%;">
                    <p class="fts-18 light-blue-01" style="font-weight: 900;">{{ comparison.name }}</p>
                    <p class="light-white-03">Secteur : {{ comparison.sector }}</p>
                    <p class="light-white-03">ISIN : {{ comparison.isin }}</p>
                    <p class="light-white-03">Plateform : {{ comparison.platform }}</p>
                    <p class="light-white-03">Contract : {{ comparison.contract }}</p>
                    <p class="fts-18 font-weight-bold light-white-03">Vous possédez actuellement <span class="light-blue-01">{{ Math.round(comparison.amount,0) }} €</span></p>
                    <p class="fts-14 m-emphasis">{{ Math.round(comparison.number_shares,0) }} parts</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'strategy',
            'client_positions',
            'cppi_strategy',
            'user',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                expected_floor_value: 0,
                floor_rate: 0.01,
                target_rate: 0.05,
                client_position: this.client_positions[0].positions,
                target_date: 1,
                valid: false,
            }
        },

        mounted() {
            this.onDataChange();


        },
        methods: {
            onDataChange(){
                // calcul ici data_av et data_ct en fonction de this.amount, this.time_horizon et this.performance

                this.expected_floor_value = Math.round(this.sum_assets*Math.pow((1+parseFloat(this.floor_rate)),this.target_date));

            },
            formatEuros(number)
            {
                return this.$utils.numberWithSpaces(Number(number).toFixed(0));
            },
        },
    }

</script>